import type { NonEmptyArray } from '@/shared/lib/types'

export function chunkBy<T>(input: T[], fn: (item: T, prevItem: T, result: T[][]) => boolean): NonEmptyArray<T>[] {
    let prevItem = input[0]
    if (prevItem === undefined) {
        return []
    }

    let chunk: NonEmptyArray<T> = [prevItem]

    const result = [chunk]

    // skip first item since it's already in the first chunk
    for (let idx = 1; idx < input.length; idx++) {
        const item = input[idx]!
        if (fn(item, prevItem, result)) {
            // add to current chunk
            chunk.push(item)
        } else {
            // start new chunk
            chunk = [item]
            result.push(chunk)
        }

        prevItem = item
    }

    return result
}
